import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../shared/services/firebase";
import "./SelectFormType.css";

const formTypes = [
  {
    id: "simple-feedback",
    name: "Simple Feedback",
    description: "A basic form for collecting open-ended feedback.",
    image: "https://via.placeholder.com/120x80?text=Simple",
  },
  {
    id: "star-rating",
    name: "Star Rating",
    description: "Collect feedback with a 1-5 star rating and optional comments.",
    image: "https://via.placeholder.com/120x80?text=Stars",
  },
  {
    id: "nps-survey",
    name: "NPS Survey",
    description: "Net Promoter Score survey with a 0-10 scale.",
    image: "https://via.placeholder.com/120x80?text=NPS",
  },
  {
    id: "emoji-feedback",
    name: "Emoji Feedback",
    description: "Let users respond with emojis and a short comment.",
    image: "https://via.placeholder.com/120x80?text=Emoji",
  },
  {
    id: "multiple-choice",
    name: "Multiple Choice",
    description: "Ask a question and let users pick from several options.",
    image: "https://via.placeholder.com/120x80?text=MCQ",
  },
  {
    id: "thumbs-feedback",
    name: "Thumbs Up/Down",
    description: "Simple thumbs up or down feedback with optional comment.",
    image: "https://via.placeholder.com/120x80?text=Thumbs",
  },
];

export default function SelectFormType({ onSelect }) {
  const [selected, setSelected] = useState(formTypes[0].id);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("Not authenticated");
      // Save the selected form type to Firestore
      await updateDoc(doc(db, "users", user.uid), {
        feedbackFormType: selected,
      });
      if (onSelect) onSelect(selected);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Failed to save selection");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="select-form-type-container">
      <h1>Select Your Feedback Form</h1>
      <form onSubmit={handleSubmit} className="select-form-type-form">
        <div className="form-type-list">
          {formTypes.map((form) => (
            <label key={form.id} className={`form-type-card${selected === form.id ? " selected" : ""}`}>
              <input
                type="radio"
                name="formType"
                value={form.id}
                checked={selected === form.id}
                onChange={() => setSelected(form.id)}
                disabled={submitting}
              />
              <img src={form.image} alt={form.name} className="form-type-image" />
              <div className="form-type-info">
                <div className="form-type-title">{form.name}</div>
                <div className="form-type-desc">{form.description}</div>
              </div>
            </label>
          ))}
        </div>
        <button type="submit" className="form-type-submit" disabled={submitting}>
          {submitting ? "Saving..." : "Continue"}
        </button>
        {error && <div className="form-type-error">{error}</div>}
      </form>
    </div>
  );
} 